// Inspired by https://youtu.be/M_SUcX66SDA Low Byte Productions Flow Fields video
const $9d8ba19c26fa1617$export$9476a5c0d391dc9e = (scale, vec)=>vec.map((n)=>n * scale);
const $9d8ba19c26fa1617$export$a30b3b91aec6ef0f = (v0, v1)=>[
        v0[0] + v1[0],
        v0[1] + v1[1]
    ];
const $9d8ba19c26fa1617$export$5a5f3d9229701e6 = (a)=>[
        Math.cos(a),
        Math.sin(a)
    ];


//const vAngle = (a) => [Math.cos(a), Math.sin(a)];
const $8cdd6f3ceee91db7$var$canvas = document.getElementById("main");
const $8cdd6f3ceee91db7$var$ctx = $8cdd6f3ceee91db7$var$canvas.getContext("2d");
const $8cdd6f3ceee91db7$var$width = 800;
const $8cdd6f3ceee91db7$var$height = 800;
// A 10x10 grid, transformed onto the canvas
const $8cdd6f3ceee91db7$var$n = 25;
const $8cdd6f3ceee91db7$var$fieldSize = $8cdd6f3ceee91db7$var$width / $8cdd6f3ceee91db7$var$n;
$8cdd6f3ceee91db7$var$canvas.setAttribute("width", $8cdd6f3ceee91db7$var$width);
$8cdd6f3ceee91db7$var$canvas.setAttribute("height", $8cdd6f3ceee91db7$var$height);
const $8cdd6f3ceee91db7$var$fill = (ctx, r = 0, g = 0, b = 0, a = 255)=>{
    ctx.fillStyle = `rgba(${r}, ${g}, ${b}, ${a})`;
};
const $8cdd6f3ceee91db7$var$stroke = (ctx, r = 0, g = 0, b = 0, a = 255)=>{
    ctx.strokeStyle = `rgba(${r}, ${g}, ${b}, ${a})`;
};
const $8cdd6f3ceee91db7$var$line = (ctx, v, v2)=>{
    ctx.beginPath();
    ctx.moveTo(...v);
    ctx.lineTo(...v2);
    ctx.stroke();
    ctx.closePath();
};
const $8cdd6f3ceee91db7$var$ellipse = (ctx, v, rx, ry = rx, oa = 0, sa = 0, ea = Math.PI * 2)=>{
    ctx.beginPath();
    ctx.ellipse(...v, rx, ry, oa, sa, ea, false);
    ctx.stroke();
    ctx.fill();
    ctx.closePath();
};
const $8cdd6f3ceee91db7$var$background = (ctx, r = 0, g = 0, b = 0, a = 255)=>{
    $8cdd6f3ceee91db7$var$fill(ctx, r, g, b, a);
    ctx.fillRect(0, 0, $8cdd6f3ceee91db7$var$width, $8cdd6f3ceee91db7$var$height);
};
$8cdd6f3ceee91db7$var$fill($8cdd6f3ceee91db7$var$ctx, 0, 0, 0, 0);
$8cdd6f3ceee91db7$var$stroke($8cdd6f3ceee91db7$var$ctx, 255, 255, 255, 1);
$8cdd6f3ceee91db7$var$background($8cdd6f3ceee91db7$var$ctx, 0, 0, 255, $8cdd6f3ceee91db7$var$width, $8cdd6f3ceee91db7$var$height);
const $8cdd6f3ceee91db7$var$vRandom = ()=>(0, $9d8ba19c26fa1617$export$5a5f3d9229701e6)(Math.random() * Math.PI * 2);
/*
for (let y = 0; y < n; y++) {
    for (let x = 0; x < n; x++) {
        const sv = vAdd([fieldSize/2, fieldSize/2], vScale(fieldSize, [x, y]));
        ellipse(ctx, sv, fieldSize/2);
    }
}
*/ let $8cdd6f3ceee91db7$var$prevTimestamp;
const $8cdd6f3ceee91db7$var$draw = (timestamp)=>{
    if ($8cdd6f3ceee91db7$var$prevTimestamp === undefined) $8cdd6f3ceee91db7$var$prevTimestamp = timestamp;
    const elapsed = timestamp - $8cdd6f3ceee91db7$var$prevTimestamp;
    if (elapsed > 500) {
        $8cdd6f3ceee91db7$var$prevTimestamp = timestamp;
        const field = Array.from({
            length: $8cdd6f3ceee91db7$var$n
        }, ()=>Array.from({
                length: $8cdd6f3ceee91db7$var$n
            }, ()=>{
                return $8cdd6f3ceee91db7$var$vRandom();
            }));
        $8cdd6f3ceee91db7$var$fill($8cdd6f3ceee91db7$var$ctx, 0, 0, 0, 0);
        $8cdd6f3ceee91db7$var$stroke($8cdd6f3ceee91db7$var$ctx, 255, 255, 255, 1);
        $8cdd6f3ceee91db7$var$background($8cdd6f3ceee91db7$var$ctx, 0, 0, 255, $8cdd6f3ceee91db7$var$width, $8cdd6f3ceee91db7$var$height);
        field.forEach((row, y)=>row.forEach((fv, x)=>{
                const sv = (0, $9d8ba19c26fa1617$export$a30b3b91aec6ef0f)([
                    $8cdd6f3ceee91db7$var$fieldSize / 2,
                    $8cdd6f3ceee91db7$var$fieldSize / 2
                ], (0, $9d8ba19c26fa1617$export$9476a5c0d391dc9e)($8cdd6f3ceee91db7$var$fieldSize, [
                    x,
                    y
                ]));
                const upper = (0, $9d8ba19c26fa1617$export$a30b3b91aec6ef0f)(sv, (0, $9d8ba19c26fa1617$export$9476a5c0d391dc9e)($8cdd6f3ceee91db7$var$fieldSize / 2, fv));
                const lower = (0, $9d8ba19c26fa1617$export$a30b3b91aec6ef0f)(sv, (0, $9d8ba19c26fa1617$export$9476a5c0d391dc9e)(-$8cdd6f3ceee91db7$var$fieldSize / 2, fv));
                $8cdd6f3ceee91db7$var$line($8cdd6f3ceee91db7$var$ctx, upper, lower);
                $8cdd6f3ceee91db7$var$fill($8cdd6f3ceee91db7$var$ctx, 255, 255, 255, 1);
                $8cdd6f3ceee91db7$var$ellipse($8cdd6f3ceee91db7$var$ctx, upper, 2);
            }));
    }
    window.requestAnimationFrame($8cdd6f3ceee91db7$var$draw);
};
$8cdd6f3ceee91db7$var$draw();


//# sourceMappingURL=index.cc463ba5.js.map
